module.exports = __webpack_public_path__ + "static/media/img4Mobile.55322b13.jpg";